import { atom } from 'jotai';

export interface LeadTrackingState {
  adExtId?: string;
  adPartnerId?: string;
}

export const leadTrackingAtom = atom<LeadTrackingState>({
  adExtId: undefined,
  adPartnerId: undefined,
});

export default leadTrackingAtom;
